import styled, { css } from 'styled-components';

import { media } from 'styles/utils';

export const Button = styled.button<ButtonProps>`
  outline: none;
  border-radius: 8px;
  border: 0;
  padding: 16px 24px;
  color: ${({ theme }) => theme.colors.blue.dark};
  display: flex;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.fonts.barlow};
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease-out;
  text-decoration: none;
  justify-content: center;
  align-items: center;

  ${({ fullWidth }) => fullWidth && css`
    width: 100%;
  `}

  ${media.desktop`
    padding: 20px 24px;
  `}

  ${({ variant, theme }) => (variant === 'yellow' || !variant) && css`
    background-color: ${theme.colors.yellow};

    ${media.desktop`
      &:hover {
        background-color: ${theme.colors.yellow.light};
      }
    `}
  `}

  ${({ variant, theme }) => variant === 'turquoise' && css`
    background-color: ${theme.colors.turquoise};
    color: ${theme.colors.white};

    ${media.desktop`
      &:hover {
        background-color: ${theme.colors.turquoise.hover};
      }
    `}
  `}

  ${({ variant, theme }) => variant === 'white' && css`
    background-color: ${theme.colors.white};
  `}

  ${({ variant, theme }) => variant === 'light' && css`
    background-color: transparent;
    color: ${theme.colors.white};

    ${media.desktop`
      &:hover {
        background-color: ${theme.colors.white.opacity};
      }
    `}
  `}

  ${({ variant, theme }) => variant === 'magenta' && css`
    background-color: ${theme.colors.magenta};
    color: ${theme.colors.white};

    ${media.desktop`
      &:hover {
        background-color: ${theme.colors.magenta};
        opacity: 0.9;
      }
    `}
  `}

  ${({ variant, theme }) => variant === 'blue' && css`
    background-color: ${theme.colors.blue.dark};
    color: ${theme.colors.white};

    ${media.desktop`
      &:hover {
        background-color: ${theme.colors.blue.dark.hover};
      }
    `}
  `}

  ${({ variant, theme }) => variant === 'lightBlue' && css`
    background-color: ${theme.colors.blue.semiLight};
    color: ${theme.colors.white};

    ${media.desktop`
      &:hover {
        background-color: ${theme.colors.turquoise};
      }
    `}
  `}

  ${({ variant, theme }) => variant === 'transparent' && css`
    background-color: transparent;
    color: ${theme.colors.blue.dark};

    ${media.desktop`
      &:hover {
        background-color: transparent};
      }
    `}
  `}

  svg {
    margin-right: 8px;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.gray.light};
    color: ${({ theme }) => theme.colors.gray.dark};
    cursor: auto;
  }
`;

type ButtonProps = {
  variant?: 'yellow' | 'white' | 'light' | 'turquoise' | 'blue' | 'transparent' | 'lightBlue' | 'magenta';
  underlined?: boolean;
  fullWidth?: boolean;
};

export const Anchor = styled(Button) <ButtonProps>`
  border: 0;
  padding: 0;
  background-color: transparent;
  font-weight: 600;

  ${({ variant, theme }) => variant === 'white' && css`
    color: ${theme.colors.blue.dark};
  `}

  ${({ underlined }) => underlined && css`
    text-decoration: underline;
  `}

  ${media.desktop`
    &:hover {
      background-color: transparent;
      text-decoration: underline;
    }
  `}
`;
